import { Node } from '@xyflow/react';
import { getReferences } from './helpers';
import type { CreateNodesFunction, ReferenceBuilderOptions } from './types';

export function createReferenceBuilder(item: any, nodes: Node[], options: ReferenceBuilderOptions) {
  const { entities, parentId } = options;

  // Getting references from the map, inside a single array
  const mappedReferences = getReferences(item, entities);

  if (!mappedReferences.length) {
    return () => undefined;
  }

  // And we render them next to each other below the corresponding node
  return (createNodes: CreateNodesFunction) =>
    mappedReferences.forEach((child) => {
      if (!child) return;

      return createNodes(nodes, child, parentId, {
        topHandleStatus: 'RELATION',
      });
    });
}

export function shouldShowBottomHandle(item: any, entities: Record<string, any>): boolean {
  return !!getReferences(item, entities)?.length;
}
